import { Fragment, useContext, useEffect, useState } from "react";
import CheckboxField from "../../../../components/checkboxField/checkboxField";
import { CheckboxFieldProps } from "../../../../components/checkboxField/types/checkboxFieldProps";
import Dropzone from "../../../../components/dropzone/dropzone";
import { DropzoneProps } from "../../../../components/dropzone/types/dropzoneProps";
import { CellContext, createColumnHelper } from "@tanstack/react-table";
import TableActions from "../../../../components/shared/table/tableActions/tableActions";
import { TableProps } from "../../../../components/shared/table/types/tableProps";
import { HeadersTable } from "../../../../helpers/featureTableConstruct";
import Table from "../../../../components/shared/table/table";
import ConfirmModal from "../../../../components/modalWindow/confirmModal";
import { ConfirmModalProps } from "../../../../components/modalWindow/types/confirmModalProps";
import { UploadProcessStatus } from "../../../../components/progressBarField/progressBarInfo/types/progressBarInfoProps";
import { ProgressBarFieldProps } from "../../../../components/progressBarField/types/progressBarFieldProps";
import ProgressBarField from "../../../../components/progressBarField/progressBarField";
import { FormFieldProps } from "../../../../components/formField/types/formFieldProps";
import FormField from "../../../../components/formField/formField";
import { apiContext } from "../../../../contexts/apiContext";
import { ButtonFieldProps } from "../../../../components/buttonField/types/buttonFieldProps";
import ButtonField from "../../../../components/buttonField/buttonField";
import { classNameBtn } from "../../../../components/shared/button/types/buttonProps";
import { stylizationVerticalAlign } from "../../../../components/shared/stylization";
import PoFormContext, { RastersAttributes } from "../../../../contexts/poFormContext";
import { notifyError } from "../../../../components/snackbar/snackbar";
import { AddProtocolRastersProps } from "../../../../services/protocolFormService/types/protocolFormServiceProps";
import { addProtocolRasters } from "../../../../services/protocolFormService/protocolFormService";
import imageCompression from 'browser-image-compression';
import { UploadProtocolImageProps } from "../../../../services/uploadFilesService/types/uploadFilesServiceProps";
import { uploadProtocolImage } from "../../../../services/uploadFilesService/uploadFilesService";
import { getMaxRasterKolejnosc } from "../../krFormView/components/shared/uploadRasters/rasterUtils";
import { getErrorMessage } from "../../../../helpers/errorHelper";

const PhotographicDocumentation = (props: any) => {
    const api = useContext(apiContext);
    const { poForm, setPoForm } = useContext(PoFormContext);
    const [sectionToggleCheckbox, setSectionToggleCheckbox] = useState(true);
    const [uploadedImages, setUploadedImages] = useState<RastersAttributes[]>([]);
    const [imageRow, setImageRow] = useState<RastersAttributes>();
    const [confirmation, setConfirmation] = useState<boolean>(false);
    const [progress, setProgress] = useState<boolean>(false);
    const [visibilityRows, setVisibilityRows] = useState<string[]>([]);
    const [rowsToFoldOut, setRowsToFoldOut] = useState<string[]>([]);
    const [errorRows, setErrorRows] = useState<string[]>([]);
    const [errorRowsMsg, setErrorRowsMsg] = useState<string>("");
    const [reload, setReload] = useState(false);
    const [focusTable, setFocusTable] = useState<boolean>(false);

    const refocus = () => {
        setFocusTable(true);
    }

    const maxFileSize: any = 1048576;  // ~ 1 MB
    const maxFileDimensions: any = 2000;
    const maxFileNumberForUpload: any = 30;

    // Validation
    useEffect(() => {
        if (poForm.config?.check && !poForm.config.isValid) {
            var errorMsg = poForm.config?.ValidationError!["rasters"]
            if (errorMsg !== '') {
                setErrorRowsMsg(errorMsg);
                getIncompleteRows();
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [poForm.config?.check])

    const getIncompleteRows = () => {
        var incompleteRowsGlobalIds: string[] = [];
        poForm.rasters?.forEach(item => {
            if (item.opis === '' || item.opis === null) incompleteRowsGlobalIds.push(item.globalid!);
        });
        setErrorRows(incompleteRowsGlobalIds);
    }

    // Toggle section checkbox 
    useEffect(() => {
        poForm.rasters?.length === 0 ? setSectionToggleCheckbox(true) : setSectionToggleCheckbox(false);

    }, [poForm.rasters])

    var checkboxFieldPropsPhotoDocToggle: CheckboxFieldProps = {
        disabled: true,
        labelName: "Brak zdjęć",
        inputChecked: sectionToggleCheckbox
    }

    // Image dropzone
    const handleConfirm = async (files: File[]) => {
        if (files.length > maxFileNumberForUpload) {
            notifyError({ message: `Próba dodania plików zakończona niepowodzeniem - maksymalna liczba wgrywanych plików to ${maxFileNumberForUpload}` });
        } else {
            var uploadedFiles: RastersAttributes[] = [];
            Promise.all(files.map(async (file) => {
                // Resize file if size or dimensions over limit
                return new Promise((resolve) => {
                    const img = new Image();
                    img.src = URL.createObjectURL(file);
                    img.onload = () => {
                        URL.revokeObjectURL(img.src);
                        resolve({ height: img.height, width: img.width });
                    }
                })
                    .then(async (res: any) => {
                        if (file.size > maxFileSize || res.height > maxFileDimensions || res.width > maxFileDimensions) {
                            await resizeFile(file)
                                .then((response: any) => {
                                    file = response as File;
                                })
                                .catch((err) => {
                                    throw Error(`Próba kompresji pliku zakończona niepowodzeniem: ${err?.message}`);
                                })
                        }

                        // Add file to progress list (uploadedFiles) with uniqe local id, set starting progress values
                        var id = crypto.randomUUID();
                        const uploadedFile = {
                            rodzaj: 'foto',
                            localUUID: id,
                            pliK_NAZWA: file.name,
                            uploadPercent: 0,
                            currentUploadStatus: UploadProcessStatus.Uploading,
                            protokoL_OBSERWACJI_GID: poForm.protocolAttributes?.globalid
                        };
                        uploadedFiles.push(uploadedFile);
                        setUploadedImages([...uploadedFiles]);

                        // Show progress bars
                        if (!progress) setProgress(true);

                        // Update progress values 
                        const handleOnUploadProgress = (progressEvent: any) => {
                            var perc = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                            uploadedFiles = uploadedFiles.map(current => current.localUUID === id ? { ...current, uploadPercent: perc, currentUploadStatus: perc === 100 ? UploadProcessStatus.Saving : current.currentUploadStatus } : current);
                            setUploadedImages([...uploadedFiles]);
                        }

                        let uploadProtocolImageProps: UploadProtocolImageProps = {
                            file: file,
                            isLandslide: props.isLandslide,
                            idNum: poForm.protocolAttributes?.obiekT_NUMER_IDENTYFIKACYJNY!,
                            waitingRoomGlobalId: poForm.waitingRoomGlobalId ? poForm.waitingRoomGlobalId : "",
                            apiBase: api.apiUrl + api.apiVersion,
                            handleOnUploadProgress: handleOnUploadProgress
                        }

                        // Upload files
                        return uploadProtocolImage(uploadProtocolImageProps)
                            .then((res: any) => {
                                uploadedFiles = uploadedFiles.map(current => current.localUUID === id ? { ...current, fileNameModified: res[1] } : current);
                                setUploadedImages([...uploadedFiles]);
                                return {
                                    path: res[0],
                                    raster: {
                                        rodzaj: 'foto',
                                        pliK_NAZWA: file.name,
                                        fileNameModified: res[1],
                                        protokoL_OBSERWACJI_GID: poForm.protocolAttributes?.globalid
                                    } as RastersAttributes
                                };
                            })
                    })
            })).then((responseUpload) => {
                // Add rasters to db (files from progress list - uploadedFiles)
                const filePath = responseUpload[0].path;
                const baseIdx = getMaxRasterKolejnosc(poForm.rasters);
                const addRasters = responseUpload.map((r, idx) => {
                    return { ...r.raster, kolejnosc: baseIdx + idx };
                })
                let addProtocolRastersProps: AddProtocolRastersProps = {
                    rastersAttributes: addRasters,
                    objectIdNumber: poForm.protocolAttributes?.obiekT_NUMER_IDENTYFIKACYJNY!,
                    isLandslide: props.isLandslide,
                    waitingRoomGlobalId: poForm.waitingRoomGlobalId,
                    filePath: filePath,
                    apiBase: api.apiUrl + api.apiVersion
                }

                return addProtocolRasters(addProtocolRastersProps)
                    .then((response: any) => {
                        // Add rasters with completed attributes to the PO object
                        var form: any = Object.assign({}, poForm);
                        if (form !== null) form.rasters = form.rasters.concat(response);
                        setPoForm(form);

                        setTimeout(() => {
                            if (sectionToggleCheckbox) setSectionToggleCheckbox(false);
                            // Hide progress bars
                            setProgress(false);
                        }, 1000);
                    })
            }).catch((ex) => {
                setProgress(false);
                const errMsg = getErrorMessage(ex, 'Próba dodania plików zakończona niepowodzeniem.');
                notifyError({ message: errMsg });
            })
        }
    }

    const acceptedFiles = [
        "image/jpg",
        "image/jpeg"
    ]

    var imageDropzoneProps: DropzoneProps = {
        multiple: true,
        disabled: progress,
        acceptedFiles: acceptedFiles,
        onConfirm: handleConfirm,
        acceptedFilesForSnackbar: ".jpg lub .jpeg",
        dropzoneText: <>
            Przeciągnij i upuść plik w formacie .jpg/.jpeg, aby dodać go do formularza.
            <br></br>Pliki powyżej 1MB lub długość boku 2000 pix będą skalowane do odpowiedniego rozmiaru.
            <br></br>Jednocześnie wgrać można maksymalnie 30 plików.
        </>
    }

    const resizeFile = (file: File) => {
        var compressionOptions = {
            maxSizeMB: maxFileSize / 1024 / 1024,
            maxWidthOrHeight: 2000
        }

        return new Promise((resolve, reject) => {
            imageCompression(file, compressionOptions)
                .then((res: any) => {
                    resolve(res);
                })
                .catch((error: any) => {
                    reject(error);
                })

        })
    }

    // Progress bars
    const getProgressBarFieldProps = (currentPercentage: number, uploadProcessStatus: UploadProcessStatus, fileName: string): ProgressBarFieldProps => {
        return {
            progressBarInfoProps: {
                currentPercentage: currentPercentage,
                fileName: fileName,
                uploadProcessStatus: uploadProcessStatus
            },
            progressBarProps: {
                currentPercentage: currentPercentage
            }
        }
    }

    // Image table

    const draggableRows = true;

    const cellAction = (properties: CellContext<any, unknown>) => {
        return (<TableActions
            row={properties.row}
            objectType={"rasters"}
            deleteClickHandler={handleDeleteClick}
            editClickHandler={handleEditClick}
            closeClickHandler={handleCloseClick}
            visibilityRows={visibilityRows}
            draggableStyle={draggableRows}
        />)
    }

    const handleDeleteClick = (row: any) => {
        setImageRow(row);
        setConfirmation(true);
    }

    const handleEditClick = (row: any) => {
        setRowsToFoldOut([...rowsToFoldOut, row.globalid]);
        setVisibilityRows([...visibilityRows, row.globalid]);
    }

    const handleCloseClick = (row: any) => {
        setRowsToFoldOut([...rowsToFoldOut.filter((item: any) => {
            return item !== row.globalid;
        })]);
        setVisibilityRows([...visibilityRows.filter((item: any) => {
            return item !== row.globalid;
        })]);
    }

    const prepareFoldoutContent = (row: any) => {

        var inputProps: FormFieldProps = {
            inputPlaceholder: "Wpisz opis pliku",
            type: "text",
            pristine: true,
            keepPristine: true,
            value: row.propozycjaOpisu,
            setValue: (event: any) => onChangeInput(event),
            style: {
                width: "100%"
            },
            className: "staticField"
        }

        const onChangeInput = (event: any) => {
            row.propozycjaOpisu = event;
            setReload(!reload)
        }

        const getBtnProps = (title: string, onClick: React.MouseEventHandler<HTMLButtonElement>): ButtonFieldProps => {
            return {
                BtnProps: {
                    onClick: onClick,
                    className: `${classNameBtn.Btn} ${classNameBtn.LargeSecondary} body-txt-medium searchBtn`
                },
                placeHolder: title,
                placeHolderStyle: stylizationVerticalAlign,
                wrapperProps: {
                    className: "searchBtnField"
                }
            };
        }

        const saveDescription = () => {
            var form: any = Object.assign({}, poForm);
            if (form !== null && form.rasters) form.rasters = form.rasters.map((current: any) => ({
                ...current,
                opis: current.globalid === row.globalid ? row.propozycjaOpisu : current.opis
            }));
            if (errorRows.length > 0 && errorRows.includes(row.globalid) &&
                (row.propozycjaOpisu !== undefined && row.propozycjaOpisu?.trim() !== "")) {
                var currentErrorRows = errorRows.filter(item => item !== row.globalid);
                setErrorRows(currentErrorRows);
            }
            setPoForm(form);
            handleCloseClick(row);
        }

        return (
            <div className="filefoldout">
                <FormField {...inputProps} />
                <ButtonField {...getBtnProps("Zapisz opis", () => { saveDescription() })}></ButtonField>
            </div>
        )
    }

    const handleReorderRows = (data: RastersAttributes[]) => {
        var numberedNewData = data.map((item: any, index: number) => {
            item.kolejnosc = index + 1;
            return item;
        })

        var form: any = Object.assign({}, poForm);
        if (form !== null) form.rasters = numberedNewData;
        setPoForm(form);
    }

    const foldoutParamToCheck = (row: any) => {
        return row.globalid;
    }

    let headers = {
        pliK_NAZWA: "Nazwa pliku",
        opis: "Opis",
        imagePreview: ""
    };

    var tablePropsImageTable: TableProps = {
        columnAliases: headers,
        columnHelper: createColumnHelper<HeadersTable>(),
        columnNames: Object.keys(headers),
        cellActions: cellAction,
        data: poForm.rasters ? poForm.rasters!.sort((a, b) => a.kolejnosc! - b.kolejnosc!) : [],
        loading: false,
        className: "table",
        draggableRows: draggableRows,
        handleReorderRows: handleReorderRows,
        foldoutRows: true,
        rowsToFoldOut: rowsToFoldOut,
        foldoutContent: prepareFoldoutContent,
        foldoutParamToCheck: foldoutParamToCheck,
        errorRows: errorRows,
        errorRowsMsg: errorRowsMsg,
        refocus: focusTable,
        setRefocusTable: setFocusTable
    }

    // Confirm delete image
    const confirm = () => {
        setConfirmation(false);
        deleteImage(imageRow);
    }

    const deleteImage = (row: any) => {
        var form: any = Object.assign({}, poForm);
        if (form !== null && form.rasters) form.rasters = form.rasters.filter((item: any) => {
            return item.globalid !== row.globalid;
        });
        setPoForm(form);
    }

    const cancel = () => {
        setConfirmation(false);
    }

    const getQuestion = () => {
        return `Czy na pewno chcesz usunąć plik ${imageRow?.pliK_NAZWA}?`;
    }

    var confirmDeleteImage: ConfirmModalProps = {
        width: "660px",
        height: "auto",
        confirmTitle: "Tak, usuń plik",
        onConfirm: confirm,
        cancelTitle: "Anuluj",
        onCancel: cancel,
        question: getQuestion(),
        refocus: refocus
    }

    return (
        <>
            <div style={{ width: "100%" }}>
                <h2>4. Dokumentacja fotograficzna</h2>
                <CheckboxField {...checkboxFieldPropsPhotoDocToggle} /> <br />
                <Dropzone {...imageDropzoneProps} /> <br />
                {progress && uploadedImages.map(image => (
                    <Fragment key={image.localUUID}>
                        <ProgressBarField {...getProgressBarFieldProps(image.uploadPercent!, image.currentUploadStatus!, image.pliK_NAZWA!)} />
                        <br />
                    </Fragment>
                ))}
                <br /><br />
                <Table {...tablePropsImageTable} /> <br />
            </div>
            {confirmation && <ConfirmModal {...confirmDeleteImage} />}
        </>
    )
}

export default PhotographicDocumentation;
